/* Shelf Space: builds the "See it in 3D & customise" link from the product + selected variant */
(function(){
  var D=window.__ss3d; if(!D) return;
  var CNT={650:2,900:3,1200:4,1800:5,2100:5,2400:5,2700:5}, HS=[650,900,1200,1800,2100,2400,2700];
  function topK(h){return Math.floor((h-147)/130)+1;}
  function stdH(h){for(var i=0;i<HS.length;i++)if(HS[i]>=h)return HS[i];return 2700;}
  function levels(h,n){var kt=topK(h);n=Math.max(1,Math.min(n,kt+1));if(n===1)return[0];var r=[0];for(var i=1;i<n-1;i++)r.push(Math.round(kt*i/(n-1)));r.push(kt);return r.filter(function(x,j){return r.indexOf(x)===j});}
  function mm(s){if(s==null)return null;s=String(s);var m=s.match(/(\d+(?:[.,]\d+)?)\s*(mm|m)\b/i);if(!m){m=s.match(/(\d{3,4})/);return m?+m[1]:null;}var n=parseFloat(m[1].replace(',','.'));return Math.round(/^m$/i.test(m[2])?n*1000:n);}
  function optVal(vals,name){if(!name)return null;var o=D.opts,i=-1;for(var j=0;j<o.length;j++)if(String(o[j]).toLowerCase()===String(name).toLowerCase())i=j;return i>=0?vals[i]:null;}
  var T=null,B=null;
  function build(vid){
    var vals=D.vars[vid]||D.vars[Object.keys(D.vars)[0]]||[];
    var hv=optVal(vals,T.heightOption), H=null;
    if(T.heightMap&&hv!=null&&T.heightMap[mm(hv)]!=null)H=T.heightMap[mm(hv)]; else H=mm(hv);
    H=stdH(H||T.h||2100);
    var Dp=mm(optVal(vals,T.depthOption))||T.depth||400; if([200,300,400,500,600].indexOf(Dp)<0)Dp=400;
    var fin=T.finish==='option'?(/premium/i.test(String(optVal(vals,'Type')||''))?'premium':'standard'):(T.finish||'standard');
    var ids=T.b; if(T.bo&&T.bayOption){var bv=optVal(vals,T.bayOption); if(bv!=null&&T.bo[bv])ids=T.bo[bv];}
    var uid=1,S={v:2,depth:Dp,finish:fin,bays:[]}; if(T.canvas)S.canvas=true; if(T.cside)S.cside=T.cside;
    ids.forEach(function(id){
      var b=B[id]; if(!b) return;
      var h=b.h||H, kt=topK(h), sh=stdH(h), items=[];
      if(b.fill){for(var k=b.fill[1];k<=kt;k++)items.push({id:uid++,type:b.fill[0],k:k});}
      else if(b.n){items=levels(h,b.n[sh]||CNT[sh]).map(function(k){return {id:uid++,type:'shelf',k:k};});}
      else{var r=(b.relByH&&b.relByH[sh])||b.rel;
        if(!r||r==='std') items=levels(h,CNT[sh]).map(function(k){return {id:uid++,type:'shelf',k:k};});
        else items=r.map(function(p){return {id:uid++,type:p[0],k:Math.max(0,Math.min(kt,Math.round(p[1]*kt)))};});}
      var bay={id:uid++,h:h,corner:false,brace:false,dowel:false,mback:false,crate:false,peg:'none',items:items};
      var f=b.flags||{}; for(var key in f) bay[key]=f[key];
      S.bays.push(bay);
    });
    if(!S.bays.length) return null;
    return btoa(unescape(encodeURIComponent(JSON.stringify(S)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  }
  var last='';
  function upd(){
    var a=document.getElementById('ss-3d'); if(!a||!T) return;
    var f=document.querySelector('.product-infors form[action*="/cart/add"] [name="id"]')||document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vid=f?String(f.value):Object.keys(D.vars)[0];
    if(vid===last) return; last=vid;
    try{var e=build(vid); if(e) a.href='/pages/build-your-shelf#d='+e;}catch(err){}
  }
  fetch(D.src).then(function(r){return r.json()}).then(function(j){
    T=j.P[D.handle]; B=j.B; if(!T||T.skip) return;
    upd(); document.addEventListener('change',function(){setTimeout(upd,60)}); document.addEventListener('click',function(){setTimeout(upd,150)}); setInterval(upd,1500);
  }).catch(function(){});
})();
